import { Box, Button, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from './ESignaureFormStyles';
import {
  addEsignInfo,
  resetEsignError,
} from '../../../../legacy/store/appReducer';
import { getEsignErrorMessage } from '../../../../legacy/constants';

const NOTES_MAX_LENGTH = 300;
/**
 * E-Signaure Form
 * @param {Function} onCancel // on cancel callback
 * @param {Function} onSubmit // on submit callback
 * @param {String} title // form title
 * @param {String} screenName // the current screen name where the form is rendered
 */

const ESignatureForm = ({ onCancel, onSubmit, title, screenName }) => {
  const [values, setValues] = useState({
    note: '',
    userName: '',
    esignPw: '',
  });
  const [errors, setErrors] = useState({
    note: '',
    userName: '',
    esignPw: '',
  });

  const classes = useStyles();
  const intl = useIntl();

  const dispatch = useDispatch();
  const esignError = useSelector(state => state.app.esignInfo.error);

  const errorMessage = getEsignErrorMessage(esignError);
  // Handle form fields validation and values change
  const handleChange = e => {
    e.preventDefault();
    if (esignError) {
      dispatch(resetEsignError());
    }
    const { name, value } = e.target;
    if (!value || (value && value.trim() === '')) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: intl.formatMessage({
          id: 'validation.message.Required',
        }),
      }));
    } else {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: '',
      }));
      setValues(prevValues => ({
        ...prevValues,
        [name]: value,
      }));
    }
  };

  // updating the state with esignInfo on submit and invoking the callback
  const handleSubmit = e => {
    e.preventDefault();
    dispatch(addEsignInfo(values, screenName));
    onSubmit();
  };

  const remainingNoteChars = NOTES_MAX_LENGTH - values.note.length;
  const remainingNoteCharsMag = (
    <FormattedMessage
      id="information.number_of_characters_remaining"
      values={{ count: remainingNoteChars < 0 ? 0 : remainingNoteChars }}
    />
  );

  const hasErrors = Object.values(errors).some(error => error !== '');
  const hasValues = Object.values(values).every(value => value.length > 0);

  const isFormValid =
    !hasErrors && hasValues && !errorMessage && remainingNoteChars >= 0;

  return (
    <form
      className={classes.form}
      onSubmit={handleSubmit}
      onChange={handleChange}
    >
      <Box className={classes.header}>
        <Typography className={classes.title}>
          <FormattedMessage id="label.signoff" />: {title}
        </Typography>
        <Typography className={classes.required}>
          *<FormattedMessage id="label.required_field" />
        </Typography>
      </Box>
      <Box className={classes.body}>
        <TextField
          variant="outlined"
          name="note"
          label={intl.formatMessage({
            id: 'label.note',
          })}
          required
          fullWidth
          multiline
          rows={4}
          autoComplete="off"
          helperText={errors.note || remainingNoteCharsMag}
          error={!!errors.note || remainingNoteChars < 0}
        />
        <TextField
          variant="outlined"
          name="userName"
          label={intl.formatMessage({
            id: 'label.username',
          })}
          required
          fullWidth
          autoComplete="off"
          helperText={errors.userName}
          error={!!errors.userName || !!errorMessage}
        />
        <TextField
          variant="outlined"
          name="esignPw"
          type="password"
          label={intl.formatMessage({
            id: 'label.esign',
          })}
          required
          fullWidth
          autoComplete="off"
          helperText={errors.esignPw || errorMessage}
          error={!!errors.esignPw || !!errorMessage}
        />
      </Box>
      <Box className={classes.footer}>
        <Button
          variant="outlined"
          className={classes.leaveButton}
          onClick={onCancel}
        >
          <FormattedMessage id="button.cancel" />
        </Button>
        <Button
          variant="contained"
          className={classes.stayButton}
          type="submit"
          disabled={!isFormValid}
        >
          <FormattedMessage id="label.signoff" />
        </Button>
      </Box>
    </form>
  );
};

export default ESignatureForm;



// WEBPACK FOOTER //
// ./src/views/components/Forms/ESignatureForm/ESignatureForm.jsx